import { render, staticRenderFns } from "./BlockType5.vue?vue&type=template&id=36f59099&scoped=true"
import script from "./BlockType5.vue?vue&type=script&lang=ts"
export * from "./BlockType5.vue?vue&type=script&lang=ts"
import style0 from "./BlockType5.vue?vue&type=style&index=0&id=36f59099&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f59099",
  null
  
)

export default component.exports